module.exports = __webpack_public_path__ + "new_role.25a410d5cd99c71cbf3fd4de6955b2fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/selected/new_role.svg
// module id = 324
// module chunks = 0